import React, { FC, MouseEvent, ReactNode } from 'react'
import styled from 'styled-components'

const ButtonContainer = styled.div`
  cursor: pointer;
  padding: 4px 12px;
  border-radius: 16px;
  background-color: ${({ theme }) => theme.forecast.background2_5};
  color: ${({ theme }) => theme.forecast.text3};
  text-wrap: nowrap;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 4px;
  transition: transform 200ms;
  width: max-content;

  &:hover {
    background-color: ${({ theme }) => theme.forecast.background3};
    transform: scale(1.1);
  }
`

interface BottomOverlayMenuButtonProps {
  onClick: (e: MouseEvent) => void
  children: ReactNode
}

export const BottomOverlayMenuButton: FC<BottomOverlayMenuButtonProps> = (
  props
) => {
  return (
    <ButtonContainer onClick={(e) => props.onClick(e)}>
      {props.children}
    </ButtonContainer>
  )
}
